export const NAVIGATION_REDUCER_STATE_ID = 'NAVIGATION_REDUCER_STATE_ID';
export const NAVIGATION_MENU_ID = 'NAVIGATION_MENU_ID';
